import { useMutation, useQueryClient } from "@tanstack/react-query";

import { saveDraw } from "../../services/draw";

import { IDraw } from "../../types/draw";
import { toast } from "react-toastify";

interface IPayload {
    data: IDraw;
    setIsProcessing: React.Dispatch<React.SetStateAction<boolean>>;
    setApiError: React.Dispatch<React.SetStateAction<string | null>>;
};

const useSaveDraw = () => {
    const queryClient = useQueryClient();

    const mutationFn = async (variables: IPayload) => {
        return await saveDraw(variables.data);
    }

    return useMutation({
        mutationFn,
        onMutate: (variables) => {
            variables.setIsProcessing(true);
            variables.setApiError('');
        },
        onSuccess: (response, variables) => {
            variables.setIsProcessing(false);
            if (response === 200) {
                toast.success('Draw saved successfully!');
                queryClient.invalidateQueries({
                    queryKey: ['draws', variables.data.category_id]
                });
            }
        },
        onError: (error: any, variables) => {
            toast.error(error?.response?.data?.message || 'An error occurred!');
            variables.setIsProcessing(false);
            variables.setApiError(error?.response?.data?.message || 'An error occurred!');
        },
        onSettled: (response: number | undefined, error: any, variables) => {
            variables.setIsProcessing(false);
        }
    })
};
export default useSaveDraw;